import { formatDate } from 'shared/functions';

export const getShopProductValues = (product, fields) =>
  fields.map(field => {
    if (field === 'category') return product.categories[0];

    if (field === 'price') {
      const pricing = (product.pricing ? product.pricing : []).find(({ active }) => active);
      return pricing.price;
    }

    if (field === 'subscriptionUntil' || field === 'purchaseDate') {
      return formatDate(product[field]);
    }

    return product[field];
  });
